export type Currency = "EUR" | "GBP" | "USD"

export const CURRENCIES_MAP: Record<Currency, string> = {
  EUR: "€",
  GBP: "£",
  USD: "$",
} as const

export function formatCurrency(currency: Currency = "EUR") {
  return CURRENCIES_MAP[currency]
}
